import React, {Fragment, useState} from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from 'react-i18next';
import {Button, Col, Form, Input, Modal, Row, Select, Tabs} from "antd";
import {
  GUTTER_MD,
  MARGIN_MD,
  MODAL_WIDTH_LG,
  MODAL_WIDTH_MD,
  MODAL_WIDTH_XL,
  SPAN_FULL,
  SPAN_HALF,
  SPAN_ONE_THIRD,
  SPAN_TWO_THIRDS
} from "../../../styles/constants";
import EnhancedModal from "../../../components/enhanced-modal";
import ArtefactForm, {ARTEFACT_FORM_MODE_CREATE} from '../../../components/artefact-form';
import Call from "../../../hocs/call";
import {isArtefactValid} from "../../../utils/artefactValidators";
import {getStringFromArtefactTriplet, getUrnFromArtefactTriplet, SDMX_JSON_DATAFLOW_URN_NAMESPACE, SDMX_JSON_DSD_URN_NAMESPACE} from "../../../utils/sdmxJson";
import {ARTEFACT_TYPE_DSD} from "../../../constants/download";
import {
  changeGenerateCCFromFileCC,
  changeGenerateCCFromFileFileForm,
  hideGenerateCCFromFileArtefacts,
  hideGenerateCCFromFileCsvRows,
  readGenerateCCFromFileAgencies,
  readGenerateCCFromFileArtefacts,
  readGenerateCCFromFileCsvRows,
  resetGenerateCCFromFileCC,
  setGenerateCCFromFileArtefact,
  setGenerateCCFromFileArtefactType,
  showGenerateCCFromFileCsvRows,
  submitGenerateCCFromFileCC,
  uploadGenerateCCFromFileFile
} from "./actions";
import Selector from "../../../components/selector";
import ArtefactList from "../../../components/artefact-list";
import {
  CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW,
  CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW_LABEL,
  CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD,
  CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD_LABEL
} from "../../../redux-components/redux-content-constraint-modal/FilterTab";
import FileInput from "../../../components/file-input";
import _ from "lodash";
import InfiniteScrollDataTable from "../../../components/infinite-scroll-data-table";
import {getFilterObjFromViewerObj} from "../../../utils/filter";

const mapStateToProps = state => ({
  permissions: state.app.user.permissions,
  agencies: state.scenes.utilities.generateCCFromFile.agencies,
  contentConstraint: state.scenes.utilities.generateCCFromFile.contentConstraint,
  artefactType: state.scenes.utilities.generateCCFromFile.artefactType,
  artefacts: state.scenes.utilities.generateCCFromFile.artefacts,
  artefact: state.scenes.utilities.generateCCFromFile.artefact,
  fileForm: state.scenes.utilities.generateCCFromFile.fileForm,
  filePath: state.scenes.utilities.generateCCFromFile.filePath,
  isPreviewVisible: state.scenes.utilities.generateCCFromFile.isPreviewVisible,
  csvRows: state.scenes.utilities.generateCCFromFile.csvRows
});

const mapDispatchToProps = dispatch => ({
  fetchAgencies: allowedAgencies => dispatch(readGenerateCCFromFileAgencies(allowedAgencies)),
  onCCChange: fields => dispatch(changeGenerateCCFromFileCC(fields)),
  onCCReset: () => dispatch(resetGenerateCCFromFileCC()),
  onCCSubmit: (contentConstraint, artefactType, artefact, filePath, separator, delimiter) =>
    dispatch(submitGenerateCCFromFileCC(contentConstraint, artefactType, artefact, filePath, separator, delimiter)),
  onArtefactTypeSet: artefactType => dispatch(setGenerateCCFromFileArtefactType(artefactType)),
  fetchArtefacts: artefactType => dispatch(readGenerateCCFromFileArtefacts(artefactType)),
  onArtefactsHide: () => dispatch(hideGenerateCCFromFileArtefacts()),
  onArtefactSet: artefact => dispatch(setGenerateCCFromFileArtefact(artefact)),
  onFileFormChange: fields => dispatch(changeGenerateCCFromFileFileForm(fields)),
  onFileUpload: fields => dispatch(uploadGenerateCCFromFileFile(fields)),
  onCsvRowsShow: () => dispatch(showGenerateCCFromFileCsvRows()),
  onCsvRowsHide: () => dispatch(hideGenerateCCFromFileCsvRows()),
  fetchCsvRows: (pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, tid, filePath, idMappingSpecialTimePeriod) =>
    dispatch(readGenerateCCFromFileCsvRows(pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, tid, filePath, idMappingSpecialTimePeriod))
});

const mapPropsToFields = ({fileForm}) => ({
  file: Form.createFormField({value: fileForm.file}),
  separator: Form.createFormField({value: fileForm.separator}),
  delimiter: Form.createFormField({value: fileForm.delimiter})
});

const onFieldsChange = (props, fields) => props.onFileFormChange(_.mapValues(fields, ({value}) => value));

const formItemLayout = {
  labelCol: {span: SPAN_ONE_THIRD},
  wrapperCol: {span: SPAN_TWO_THIRDS}
};

const TAB_GENERAL = "TAB_GENERAL";
const TAB_CONSTRAINT_ITEMS = "TAB_CONSTRAINT_ITEMS";
const TAB_LOAD_FILE = "TAB_LOAD_FILE";

const GenerateCCFromFile = ({
                              t,
                              form,
                              permissions,
                              agencies,
                              contentConstraint,
                              artefactType,
                              artefacts,
                              artefact,
                              fileForm,
                              filePath,
                              isPreviewVisible,
                              csvRows,
                              fetchAgencies,
                              onCCChange,
                              onCCReset,
                              onCCSubmit,
                              onArtefactTypeSet,
                              fetchArtefacts,
                              onArtefactsHide,
                              onArtefactSet,
                              onFileUpload,
                              onCsvRowsShow,
                              onCsvRowsHide,
                              fetchCsvRows
                            }) => {

  const [visible, setVisibility] = useState(true);

  const [tabId, setTabId] = useState(TAB_GENERAL);

  const handleClose = close => {
    Modal.confirm({
      title: t('scenes.utilities.generateCCFromFile.confirm.reset.title'),
      content: t('scenes.utilities.generateCCFromFile.confirm.reset.content'),
      onOk() {
        onCCReset();
        setVisibility(!close);
        setTabId(TAB_GENERAL);
      },
      cancelText: t('commons.buttons.cancel.title')
    })
  }

  return (
    <Call cb={fetchAgencies} cbParam={permissions ? permissions.agencies : undefined}>
      <EnhancedModal
        visible={agencies !== null && visible}
        title={t('scenes.utilities.generateCCFromFile.title')}
        width={MODAL_WIDTH_XL}
        onCancel={() => handleClose(true)}
        footer={
          <Fragment>
            {/*<Button onClick={() => handleClose(false)}>*/}
            {/*  {t('commons.buttons.reset.title')}*/}
            {/*</Button>*/}
            <Button onClick={() => handleClose(true)}>
              {t('commons.buttons.close.title')}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                if (isArtefactValid(contentConstraint) && artefactType !== null && artefact !== null && filePath !== null) {
                  onCCSubmit(
                    contentConstraint,
                    artefactType,
                    getUrnFromArtefactTriplet(
                      artefact,
                      artefactType === ARTEFACT_TYPE_DSD
                        ? SDMX_JSON_DSD_URN_NAMESPACE
                        : SDMX_JSON_DATAFLOW_URN_NAMESPACE
                    ),
                    filePath,
                    fileForm.separator,
                    fileForm.delimiter
                  )
                } else {
                  Modal.warning({
                    title: t('commons.alerts.invalidForm.title'),
                    content: t('commons.alerts.invalidForm.content')
                  });
                  if (!isArtefactValid(contentConstraint)) {
                    setTabId(TAB_GENERAL);
                  } else if (artefactType === null || artefact === null) {
                    setTabId(TAB_CONSTRAINT_ITEMS);
                  } else {
                    setTabId(TAB_LOAD_FILE);
                  }
                }
              }}
            >
              {t("commons.buttons.save.title")}
            </Button>
          </Fragment>
        }
        withDataLanguageSelector
      >
        <Tabs activeKey={tabId} onTabClick={key => setTabId(key)}>
          <Tabs.TabPane
            key={TAB_GENERAL}
            tab={t('commons.artefact.tabs.general.title')}
          >
            <ArtefactForm
              artefact={contentConstraint}
              mode={ARTEFACT_FORM_MODE_CREATE}
              agencies={agencies}
              onChange={onCCChange}
            />
          </Tabs.TabPane>
          <Tabs.TabPane
            key={TAB_CONSTRAINT_ITEMS}
            tab={t('scenes.metaManager.commons.detail.tabs.constraintItems.title')}
          >
            <Row gutter={GUTTER_MD}>
              <Col span={SPAN_HALF}>
                <Form.Item
                  label={t('scenes.metaManager.commons.detail.tabs.constraintItems.select.title')}
                  className="form-item-required"
                  {...formItemLayout}
                >
                  <Select
                    value={artefactType}
                    onChange={onArtefactTypeSet}
                    style={{width: "100%"}}
                    showSearch
                    filterOption={(inputValue, {props}) =>
                      props.title.toLowerCase().includes(inputValue.toLowerCase())
                    }
                  >
                    <Select.Option
                      value={CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW}
                      title={CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW_LABEL}
                    >
                      {CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW_LABEL}
                    </Select.Option>
                    <Select.Option
                      value={CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD}
                      title={CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD_LABEL}
                    >
                      {CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD_LABEL}
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={SPAN_HALF}>
                <Form.Item
                  label={t('scenes.metaManager.commons.detail.tabs.constraintItems.selector.title')}
                  className="form-item-required"
                  {...formItemLayout}
                >
                  <Selector
                    value={artefact ? getStringFromArtefactTriplet(artefact) : null}
                    selectTitle={t('scenes.metaManager.commons.detail.tabs.constraintItems.selector.select.title')}
                    resetTitle={t('scenes.metaManager.commons.detail.tabs.constraintItems.selector.reset.title')}
                    onSelect={() => fetchArtefacts(artefactType)}
                    onReset={() => onArtefactSet(null)}
                    disabled={!artefactType}
                  />
                </Form.Item>
              </Col>
            </Row>
            <EnhancedModal
              visible={artefacts !== null}
              onCancel={onArtefactsHide}
              title={t('scenes.metaManager.commons.detail.modals.artefactList.title')}
              width={MODAL_WIDTH_LG}
              footer={<Button onClick={onArtefactsHide}>{t('commons.buttons.close.title')}</Button>}
            >
              <Call cb={fetchArtefacts} cbParam={artefactType} disabled={artefacts !== null}>
                <ArtefactList
                  artefacts={artefacts}
                  getIsDisabledRow={({isFinal}) => !isFinal}
                  onRowClick={({id, agencyID, version}) => onArtefactSet({id, agencyID, version})}
                />
              </Call>
            </EnhancedModal>
          </Tabs.TabPane>
          <Tabs.TabPane
            key={TAB_LOAD_FILE}
            tab={t('scenes.utilities.generateCCFromFile.tabs.loadFile.title')}
          >
            <Form className="advanced-form">
              <Row type="flex" justify="center">
                <Col span={SPAN_FULL} style={{width: MODAL_WIDTH_MD}}>
                  <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                    <Col span={SPAN_FULL}>
                      <Form.Item className="form-item-required" label={t('data.csv.file.label')}>
                        {form.getFieldDecorator('file')(
                          <FileInput accept=".csv"/>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                    <Col span={SPAN_HALF}>
                      <Form.Item className="form-item-required" label={t('data.csv.separator.label')}>
                        {form.getFieldDecorator('separator')(
                          <Input maxLength={1}/>
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={SPAN_HALF}>
                      <Form.Item label={t('data.csv.delimiter.label')}>
                        {form.getFieldDecorator('delimiter')(
                          <Input maxLength={1}/>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row type="flex" justify="center" gutter={GUTTER_MD}>
                    <Col>
                      <Button
                        icon="upload"
                        type="primary"
                        onClick={() => onFileUpload(fileForm.file)}
                        disabled={fileForm.file === null || (fileForm.separator || "").length !== 1}
                      >
                        {t('data.csv.uploadButton.label')}
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        icon="table"
                        onClick={onCsvRowsShow}
                        disabled={filePath === null}
                      >
                        {t('data.csv.previewButton.label')}
                      </Button>
                    </Col>
                    <EnhancedModal
                      visible={isPreviewVisible}
                      onCancel={onCsvRowsHide}
                      title={t('scenes.dataManager.loader.csvForm.rowList.title')}
                      width={MODAL_WIDTH_LG}
                      footer={<Button onClick={onCsvRowsHide}>{t('commons.buttons.close.title')}</Button>}
                    >
                      {isPreviewVisible && (
                        <InfiniteScrollDataTable
                          data={csvRows && csvRows.Data}
                          rowTotal={csvRows && csvRows.Count}
                          cols={csvRows && csvRows.Columns}
                          hiddenCols={['NumRow']}
                          onChange={({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) => fetchCsvRows(
                            pageNum,
                            pageSize,
                            getFilterObjFromViewerObj(
                              csvRows &&
                              csvRows.Columns.filter(colName => colName !== 'NumRow'),
                              searchText,
                              filters
                            ),
                            sortCol ? [sortCol] : null,
                            sortByDesc,
                            fileForm.separator,
                            fileForm.delimiter,
                            true,
                            null,
                            filePath,
                            null
                          )}
                        />
                      )}
                    </EnhancedModal>
                  </Row>
                </Col>
              </Row>
            </Form>
          </Tabs.TabPane>
        </Tabs>
      </EnhancedModal>
    </Call>
  )
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
)(GenerateCCFromFile);
